import React from 'react';
import { RecursiveMenu } from '@uncinc/react-drupal-core';

import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import SearchInput from '../../../../containers/Search/SearchInput';

import './style.scss';

interface OverlayProps {
  setIsOverlayOpen: (value: boolean) => void;
  isOverlayOpen: boolean;
}

const Overlay = ({ setIsOverlayOpen, isOverlayOpen }: OverlayProps) => {
  const { t } = useTranslation();

  return (
    <div className="Overlay">
      <Container>
        {isOverlayOpen && (
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <SearchInput />
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-7 col-lg-5 offset-lg-1">
            <RecursiveMenu
              navProps={{ 'aria-label': 'Main menu' }}
              menuId="main"
              maxLevel={1}
              additionalClassName="magic-line magic-line--thick"
              onClickFunction={() => setIsOverlayOpen(false)}
            />
          </div>

          <div className="col-md-5 offset-lg-1 col-lg-4">
            <RecursiveMenu
              navProps={{ 'aria-label': 'Secondary navigation menu' }}
              menuId="secondary-navigation"
              maxLevel={1}
              additionalClassName="magic-line"
              onClickFunction={() => setIsOverlayOpen(false)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <Button
              className="Button__login icon-after icon-arrow-top-right icon-variant-1"
              href="/leden-login"
              onClick={() => setIsOverlayOpen(false)}
            >
              <span>{t('navigation.login_overlay')}</span>
            </Button>
          </div>
        </div>

        <div className="Overlay__footer">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <RecursiveMenu
                navProps={{ 'aria-label': 'Overlay footer menu' }}
                menuId="secondary-footer"
                maxLevel={1}
                className="Overlay__footer"
                additionalClassName="magic-line thin"
                onClickFunction={() => setIsOverlayOpen(false)}
              />
            </div>
          </div>
        </div>

      </Container>
    </div>
  );
};

export default Overlay;
